/* ============================================================
   MD · Funda with Options controller
   - Cards "Lleva 1" / "Lleva 2" como radio (click = select)
   - <select> variantes nativos → update internal variant ID
   - "Agregar al carrito" → /cart/add.js con qty 1 ó 2 del funda
   - Free gifts (cajas) NO se agregan acá; BXGY nativo Shopify los inyecta
   - Abre Horizon native cart drawer / PAWS_CART_OPEN fallback
   ============================================================ */

(function () {
  'use strict';

  /* ----- helpers ----- */
  const parseJSONAttr = (str, fallback) => {
    if (!str) return fallback;
    try { return JSON.parse(str); } catch { return fallback; }
  };

  const formatCLP = (cents) =>
    '$' + Math.round((Number(cents) || 0) / 100).toLocaleString('es-CL').replace(/,/g, '.');

  const variantFeaturedImageUrl = (variant) => {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.image && variant.image.src) return variant.image.src;
    if (typeof variant.featured_image === 'string') return variant.featured_image;
    return null;
  };

  const ensureProtocol = (url) => {
    if (!url) return url;
    if (url.startsWith('//')) return window.location.protocol + url;
    return url;
  };

  /* ----- relocate inside product-info container if posible ----- */
  function relocateSection() {
    const section = document.querySelector('section[data-md-fop]');
    if (!section || section.dataset.fopRelocated === 'true') return;

    const infoContainer =
      document.querySelector('.product-information') ||
      document.querySelector('product-information') ||
      document.querySelector('.product__info-container') ||
      document.querySelector('.product__info-wrapper');
    if (!infoContainer) return;

    let anchor = null;
    const looxBlocks = infoContainer.querySelectorAll(
      '.shopify-app-block[id*="loox_reviews_loox_snippets_widget"],' +
      ' .shopify-app-block[id*="loox_reviews_loox_rating"]'
    );
    looxBlocks.forEach((el) => { anchor = el; });
    if (!anchor) anchor = infoContainer.querySelector('.price, [data-product-price]');
    if (!anchor) anchor = infoContainer.firstElementChild;
    if (!anchor || !anchor.parentNode) return;

    anchor.parentNode.insertBefore(section, anchor.nextSibling);
    section.dataset.fopRelocated = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateSection);
  } else {
    relocateSection();
  }
  setTimeout(relocateSection, 400);
  setTimeout(relocateSection, 1200);
  setTimeout(relocateSection, 2500);

  /* ----- open Horizon native cart drawer ----- */
  async function openCart(addData) {
    /* dispatch generic cart events for theme listeners */
    try {
      ['cart:add', 'cart:added', 'cart-add', 'cartadd'].forEach((name) => {
        try {
          document.dispatchEvent(new CustomEvent(name, {
            detail: { data: addData, source: 'md-funda-with-options' },
            bubbles: true,
          }));
        } catch (e) { /* ignore */ }
      });
    } catch (e) { /* ignore */ }

    /* preferred Paws hook if present */
    try {
      if (typeof window.PAWS_CART_OPEN === 'function') {
        window.PAWS_CART_OPEN();
        return true;
      }
    } catch (e) { /* ignore */ }

    /* Horizon native drawer */
    try {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
    } catch (e) { /* ignore */ }

    /* Legacy drawer fallback */
    try {
      const legacyDrawer = document.querySelector('cart-drawer, #CartDrawer');
      if (legacyDrawer) {
        if (typeof legacyDrawer.open === 'function') { legacyDrawer.open(); return true; }
        if (typeof legacyDrawer.showModal === 'function') { legacyDrawer.showModal(); return true; }
        legacyDrawer.setAttribute('open', '');
        return true;
      }
    } catch (e) { /* ignore */ }

    return false;
  }

  /* ----- main wiring ----- */
  document.querySelectorAll('[data-md-fop]').forEach((root) => {
    const configEl = root.querySelector('[data-md-fop-config]');
    const config = configEl ? parseJSONAttr(configEl.textContent, {}) : {};
    const variants = config.variants || [];
    const options = config.options || [];

    const cards = Array.from(root.querySelectorAll('[data-md-fop-card]'));
    const addBtn = root.querySelector('[data-md-fop-add]');
    const buyBtn = root.querySelector('[data-md-fop-buy]');
    const variantsBody = root.querySelector('[data-md-fop-variants-body]');
    const toggleBtn = root.querySelector('[data-md-fop-toggle]');
    const toggleText = root.querySelector('[data-md-fop-toggle-text]');

    /* internal state */
    let selectedCardId = 'lleva1';
    let selectedQty = 1;
    let selectedVariant =
      variants.find((v) => v.id === config.default_variant_id) ||
      variants[0] ||
      null;

    /* ----- variant resolution from current <select>s ----- */
    const resolveVariant = () => {
      if (config.has_only_default_variant || variants.length <= 1) {
        return variants[0] || null;
      }
      const selectedByName = {};
      root.querySelectorAll('[data-md-fop-option-name]').forEach((sel) => {
        selectedByName[sel.dataset.mdFopOptionName] = sel.value;
      });
      const matched = variants.find((v) =>
        (v.options || []).every((optVal, idx) => {
          const optName = options[idx] && options[idx].name;
          return selectedByName[optName] === optVal;
        })
      );
      return matched || variants[0] || null;
    };

    /* ----- update DOM after variant change ----- */
    const updateOnVariantChange = () => {
      selectedVariant = resolveVariant();
      if (!selectedVariant) return;

      /* swap thumbnail images on both cards */
      const newUrl = variantFeaturedImageUrl(selectedVariant);
      if (newUrl) {
        root.querySelectorAll('.md-fop__thumb-img').forEach((img) => {
          const currentSrc = img.currentSrc || img.src || '';
          if (currentSrc.split('?')[0] !== ensureProtocol(newUrl).split('?')[0]) {
            img.removeAttribute('srcset');
            img.src = ensureProtocol(newUrl);
          }
        });
      }

      /* update displayed price on card 1 if it follows variant price */
      const price1 = root.querySelector('[data-md-fop-price-1]');
      if (price1 && (!config.lleva1_price || config.lleva1_price === selectedVariant.price)) {
        price1.textContent = formatCLP(selectedVariant.price);
      }
    };

    /* ----- select a card (radio behavior) ----- */
    const selectCard = (cardId) => {
      cards.forEach((c) => {
        const isSel = c.dataset.cardId === cardId;
        c.classList.toggle('is-selected', isSel);
        c.setAttribute('aria-checked', isSel ? 'true' : 'false');
        if (isSel) {
          selectedCardId = cardId;
          selectedQty = Number(c.dataset.qty) || 1;
        }
      });
    };

    /* ----- variants toggle (Ocultar/Mostrar) ----- */
    if (toggleBtn && variantsBody) {
      toggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isHidden = variantsBody.hasAttribute('hidden');
        if (isHidden) {
          variantsBody.removeAttribute('hidden');
          toggleBtn.setAttribute('aria-expanded', 'true');
          if (toggleText) toggleText.textContent = 'Ocultar';
        } else {
          variantsBody.setAttribute('hidden', '');
          toggleBtn.setAttribute('aria-expanded', 'false');
          if (toggleText) toggleText.textContent = 'Mostrar';
        }
      });
    }

    /* ----- wire card clicks ----- */
    cards.forEach((card) => {
      card.addEventListener('click', (e) => {
        /* avoid toggling when clicking inside <select> or toggle button */
        if (e.target.closest('select')) return;
        if (e.target.closest('[data-md-fop-toggle]')) return;
        selectCard(card.dataset.cardId);
      });
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card.dataset.cardId);
        }
      });
    });

    /* ----- wire variant selects ----- */
    root.querySelectorAll('[data-md-fop-option-name]').forEach((sel) => {
      sel.addEventListener('change', () => {
        updateOnVariantChange();
      });
      /* don't bubble up to card click */
      sel.addEventListener('click', (e) => e.stopPropagation());
    });

    /* ----- add to cart action ----- */
    const addToCart = async (redirectAfter) => {
      if (!selectedVariant || !selectedVariant.available) {
        alert('Variante no disponible. Elige otro color.');
        return false;
      }
      const targetBtn = redirectAfter ? buyBtn : addBtn;
      if (targetBtn) targetBtn.disabled = true;
      const originalHTML = targetBtn ? targetBtn.innerHTML : '';
      if (targetBtn) {
        targetBtn.innerHTML = '<span class="md-fop__cta-text">Agregando...</span>';
      }

      let succeeded = false;
      let addData = null;
      try {
        const items = [{
          id: selectedVariant.id,
          quantity: selectedQty,
          properties: {
            '_fop_bundle': selectedCardId,
            '_fop_funda': config.funda_handle,
          },
        }];

        // Auto-add gift item (caja regalo) when configured.
        // BXGY discount Shopify auto-applies 100% off on the gift line.
        const giftVariantId = config.gift_variant_id;
        if (giftVariantId) {
          items.push({
            id: giftVariantId,
            quantity: selectedQty,
            properties: {
              '_fop_gift': 'true',
              '_fop_for': config.funda_handle,
            },
          });
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        addData = await res.json();
        succeeded = true;
        console.log('[md-fop] add ok', { qty: selectedQty, variant: selectedVariant.id });
      } catch (err) {
        console.error('[md-fop] error:', err);
        alert('Hubo un problema agregando al carrito. Intenta de nuevo.');
      } finally {
        if (targetBtn) {
          targetBtn.disabled = false;
          targetBtn.innerHTML = originalHTML;
        }
      }

      if (succeeded) {
        if (redirectAfter) {
          window.location.href = '/checkout';
          return true;
        }
        const opened = await openCart(addData);
        if (!opened) {
          console.warn('[md-fop] no drawer opened; cart updated silently');
        }
      }
      return succeeded;
    };

    if (addBtn) addBtn.addEventListener('click', () => addToCart(false));
    if (buyBtn) buyBtn.addEventListener('click', () => addToCart(true));

    /* ----- init ----- */
    selectCard(selectedCardId);
    updateOnVariantChange();
  });
})();
